<div class="pagination-wrapper">
  @if (isDefault()) {
    <div>
      {{ "Pagination.ResultRange" | translate: { first: firstItem(), last: lastItem(), total: totalItems() } }}
    </div>
    <pagination-default (nextPage)="nextPage()" (prevPage)="prevPage()" [pageInfo]="pageInfo()"></pagination-default>
  }
  @if (isNumbered()) {
    <div></div>
    <pagination-numbered
      (pageChange)="toPage($event)"
      (pageSizeChanged)="onPageSizeChanged($event)"
      [pageInfo]="pageInfo()"
    ></pagination-numbered>
  }
</div>
